import React, { useState, useMemo } from 'react'
import Select from 'react-select'
import countryList from 'react-select-country-list'
import star_icon from '../../assets/images/icons/star-icon.png'






const CountrySelector = (props)=>{
    const options = useMemo(() => countryList().getData(), [])
    return (
    <div className="horizontal-text-input-container">
        <div className="horizontal-text-input-header">
            <span className="general-span-text-none-auto-small">{props.title}</span>
            {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
        </div>
        <div className="dashboard-textfield-input" style={{
            marginTop: 5,
            marginRight: 5
        }}>
            <Select 
                options={options} 
                value={props.nationality} 
                onChange={props.handleNationality}
                className="vertical-select-field"
                />
        </div>
    </div>
    );
}

export default CountrySelector